module.exports = __webpack_public_path__ + "img/shop7-6.a10d58d0.png";